module.exports = __webpack_public_path__ + "img/note-2.2fea2c61.svg";